import React, { useEffect } from "react";
import { Header } from "../Layout/Header.jsx";
import { ObavijestiCasino } from "../Layout/ObavijestiCasino.jsx";
import { MetaTags } from "../Layout/MetaTags.jsx";
import { AccountTabletLinkovi } from "../../Components/Account/AccountTabletLinkovi.jsx";
import { RestrictedAccess } from "../../Components/Layout/RestrictedAccess.jsx";

export default function AccountSuperKlub(props) {
    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.user) {
            if (document.getElementById("loyalty")) {
                (function (d, id) {
                    let js, fjs = d.getElementsByTagName('script')[0];
                    if (d.getElementById(id)) {
                        window.loyaltyApp && window.loyaltyApp.init("loyalty", "mobile", "account/superklub");
                        return;
                    }
                    js = d.createElement('script'); js.id = id;
                    js.async = true;
                    js.onload = function () {
                        window.loyaltyApp && window.loyaltyApp.init("loyalty", "mobile", "account/superklub");
                    };
                    js.src = "https://www.supersport.hr/superklub/assets/scripts/loyalty-ui/latest/s2/main.js?t=" + casino.utils.generateMinuteTimestamp(10);
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'loyalty-ui'));
            }

        }
    }, [props.user]);

    // Intercept React Router navigation and redirect to a native browser
    // navigation instead. This forces a full page reload which naturally
    // tears down the loyalty widget's WebSocket, CSS, JS, and React tree.
    useEffect(() => {
        if (!props.user || !props.route || !props.route.history) return;

        var unblock = props.route.history.block(function (location, action) {
            unblock();
            // React Router strips the BrowserRouter basename from
            // location.pathname — build the full URL via getBaseUrl.
            var baseUrl = casino.utils.getBaseUrl();
            if (baseUrl.lastIndexOf('/') === baseUrl.length - 1) {
                baseUrl = baseUrl.substring(0, baseUrl.length - 1);
            }
            var targetUrl = baseUrl + location.pathname + location.search + location.hash;

            window.setTimeout(function () {
                window.location.replace(targetUrl);
            }, 0);

            return false;
        });

        return function () { unblock(); };
    }, [props.route, props.user]);

    return (
        <>
            <MetaTags title="SuperKlub | SuperCasino" description="SuperKlub | SuperCasino | Postani dio Ekskluzivnog Casino Kluba | SuperCasino" />
            <Header key="header" {...props} />
            <div className="flex margin-1p-on-tablet">
                {props.user && <AccountTabletLinkovi {...props} />}
                <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding account-obavijesti-page" style={{ minHeight: 400 }}>
                    <div id="loyalty" className="loyalty"></div>
                </div>
            </div>
            {props.user && <ObavijestiCasino {...props} />}
        </>
    )
}